import React from "react";
import { motion } from "framer-motion";

const SkeletonCard = ({ className = "" }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    className={`bg-white dark:bg-[#1F2937] border border-[#E5E7EB] dark:border-[#374151] rounded-card p-6 shadow-subtle relative overflow-hidden ${className}`}
  >
    <div className="animate-pulse">
      <div className="h-4 bg-[#E5E7EB] dark:bg-[#374151] rounded mb-3"></div>
      <div className="h-8 bg-[#E5E7EB] dark:bg-[#374151] rounded mb-2"></div>
      <div className="h-3 bg-[#F3F4F6] dark:bg-[#374151] rounded"></div>
    </div>
    {/* Shimmer effect */}
    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-[#F3F4F6]/50 dark:via-[#374151]/50 to-transparent"></div>
  </motion.div>
);

const MatrixLoader = () => {
  return (
    <div className="w-full min-h-screen bg-[#FAFAFA] dark:bg-[#111827] py-6 px-4 sm:px-8">
      <div className="flex justify-center items-center py-24 w-full">
        <div className="w-full max-w-6xl flex flex-col gap-6">
          {/* Top priority cards skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 w-full">
            {[...Array(4)].map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
          
          {/* Equity curve skeleton */}
          <SkeletonCard className="h-80" />
          
          {/* Key stats skeleton */}
          <div className="grid grid-cols-2 md:grid-cols-6 gap-6 w-full">
            {[...Array(6)].map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
          
          {/* Streaks and trades skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            <SkeletonCard className="h-48" />
            <div className="flex flex-col gap-4">
              <SkeletonCard />
              <SkeletonCard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrixLoader; 